<template>
  <a-modal v-model:visible="applyVisible" class="applyDialog" width="600px" @cancel="handleCancel" @ok="handleOk">
    <h3>报名信息</h3>
    <a-form ref="applyFormRef" class="applyForm" :model="applyForm" :rules="applyFormRules" :labelCol="{ span: 12 }"
      layout="vertical">
      <template v-if="applyParams.isFillForm == 0">
        <a-form-item name="name" label="您的姓名">
          <a-input v-model:value="applyForm.name" placeholder="请输入您的姓名" allow-clear />
        </a-form-item>
        <a-form-item name="email" label="邮箱">
          <a-input v-model:value="applyForm.email" placeholder="请输入您的邮箱" allow-clear />
        </a-form-item>
        <a-form-item name="type" label="行业类型" required>
          <a-select ref="typeSelect" v-model:value="applyForm.type">
            <a-select-option value="0">--请选择--</a-select-option>
            <a-select-option value="1">电商</a-select-option>
            <a-select-option value="2">游戏</a-select-option>
            <a-select-option value="3">APP</a-select-option>
            <a-select-option value="4">服务商</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item name="company" label="公司名称" required>
          <a-input v-model:value="applyForm.company" placeholder="请输入公司名称" allow-clear />
        </a-form-item>
        <a-form-item name="site" label="是否合作" required>
          <a-select ref="select" v-model:value="applyForm.site">
            <a-select-option value="0">--请选择--</a-select-option>
            <a-select-option value="1">是</a-select-option>
            <a-select-option value="2">否</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item name="remark" label="备注">
          <a-textarea v-model:value="applyForm.remark" :rows="4" />
        </a-form-item>
      </template>
      <template v-if="surveyForm.type == 1">
        <template v-for="(item, index) in surveyForm.forms" :key="index">
          <a-form-item :rules="[
            { required: item.is_required == 1 ? true : false, message: '请选择' + item.problem, trigger: 'change' },
          ]">
            <template #label>
              <span class="labelName">{{ item.problem }}</span>
              <span style="color: #ff4d4f" v-if="item.is_required == 1">(必填)</span>
            </template>
            <a-input v-model:value="item.value" :placeholder="item.problem" allow-clear v-if="item.type == 0" />
            <a-radio-group v-model:value="item.value" :options="item.answer" v-if="item.type == 1" />
            <a-checkbox-group v-model:value="item.value" :options="item.answer" v-if="item.type == 2" />
            <a-select ref="select" v-model:value="item.value" :options="item.answer" v-if="item.type == 3" />
            <a-textarea v-model:value="item.value" :rows="4" v-if="item.type == 4" />
          </a-form-item>
        </template>
      </template>
    </a-form>
    <p class="tips" v-if="applyParams.isFillForm == 0">
      <i>* </i>您通过提供联系方式授权YinoLink易诺（或我们信任的合作伙伴）就我们的服务或营销目的与您联系。您有权随时撤回该授权。
    </p>
    <div class="agreeBox" v-if="applyParams.isFillForm == 0">
      <a-checkbox v-model:checked="agreeChecked">同意</a-checkbox>
    </div>
    <template #footer>
      <a-button class="applySubmit" key="submit" type="primary"
        :disabled="agreeChecked == false && applyParams.isFillForm == 0" @click="handleOk">提交</a-button>
    </template>
  </a-modal>

  <a-modal wrapClassName="codeModal" v-model:visible="codeVisible" title="" width="430px" :centered="true"
    @cancel="codeModalCancel">
    <template #footer></template>
    <div class="codeBg">
      <img class="server_qrcode" :src="live_code" alt="" />
    </div>
  </a-modal>
</template>

<script>
import { handleEventTracking } from '@/request/api/common'

export default {
  name: 'ApplyDialog',
  data() {
    let checkMobile = async (rule, value) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      if (value === '') {
        return Promise.reject('请输入手机号')
      } else if (!regMobile.test(value)) {
        return Promise.reject('请输入有效的电话号码')
      } else {
        return Promise.resolve()
      }
    }
    return {
      userInfo: '',
      applyVisible: false,
      applyForm: {
        name: '',
        email: '',
        type: '0',
        company: '',
        site: '0',
        remark: '',
      },
      applyFormRules: {
        name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱号码', trigger: 'blur' },
          {
            pattern: /(^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/,
            message: '请输入正确格式的邮箱号码',
            trigger: 'blur',
          },
        ],
        type: [{ pattern: /[^0]+/, message: '请选择类型', trigger: 'change' }],
        site: [{ pattern: /[^0]+/, message: '请选择是否合作', trigger: 'change' }],
      },
      applyParams: {},
      agreeChecked: false,
      surveyForm: [],
      // isFillForm等于0的时候显示额外表单
      live_code: '',
      codeVisible: false,
      is_added: true,
      pushId: 0
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.$bus.on('applyDialog', (e) => {
      this.openApplyDialog()
      this.applyParams = e
      console.log(this.applyParams)
      this.getBottomForm()
    })
  },
  methods: {
    openApplyDialog() {
      this.applyVisible = true
    },
    async getBottomForm() {
      const { data: res } = await this.$http.post('live/form', {
        id: this.applyParams.id,
        type: this.applyParams.type,
      })
      this.surveyForm = res.form
    },
    async handleOk() {
      if (this.applyParams.isFillForm == 1) {
        if (this.applyParams.type == 'course') {
          this.$bus.emit('surveyFormData', { surveyForm: this.surveyForm })
        } else {
          this.$bus.emit('surveyFormData1', { surveyForm: this.surveyForm })
        }
        this.$refs.applyFormRef.resetFields()
        this.applyVisible = false
        return
      }
      try {
        const values = await this.$refs.applyFormRef.validateFields()
        const { data: res } = await this.$http.post('index/write_form', {
          name: values.name,
          email: values.email,
          business_type: values.type,
          company: values.company,
          is_website: values.site,
          note: values.remark,
          _id: this.applyParams.id,
          form_type: this.applyParams.type,
        })
        if (res.code == 100) {
          this.$message.warning(`${res.msg}`)
          this.$refs.applyFormRef.resetFields()
          this.applyVisible = false
          return
        }
        if (res.code == 300) {
          this.$message.warning('登录已失效')
          window.localStorage.clear()
          this.$router.push('/index')
        }
        if (res.code == 200) {
          this.$message.success('提交成功')
          wlRegisterComp.linkToWL(
            {
              wl_qrcode_id: '1597886613810147328', // 需要使用的智能码ID
              client_user_id: this.userInfo.phone, // 用户在贵公司平台的唯一
              sign_mode: false, // 可选参数 不传时默认false 是否校验签名
              sign: '', //string 可选参数 sign_mode为true时传输 加密后的签名
              current_time: 0, //可选参数 sign_mode为true时传输 加密签名时使用的毫秒时间戳
              formData: {
                联系人: values.name,
                手机号: this.userInfo.phone,
                公司名称: values.company,
                邮箱: values.email,
              }, // 用户填写的注册或登录信息，value可以为空，但key值必填
              is_update: true, // 此次提交是否为数据更新，默认false
            },
            (data) => {
              // live_code
              handleEventTracking({ type: 4, phone: this.userInfo.phone, value: JSON.stringify(data) })
              if (data.msg == '当前用户已加好友') {
                if (this.applyParams.type == 'course') {
                  this.$bus.emit('applyCourse', { isFillForm: '1', surveyForm: this.surveyForm })
                } else {
                  this.$bus.emit('apply', { isFillForm: '1', surveyForm: this.surveyForm })
                }

                this.$refs.applyFormRef.resetFields()
                this.applyVisible = false
                window.location.reload()
              } else {
                this.live_code = data.data.live_code

                wlRegisterComp.checkUserState(
                  this.userInfo.phone, // 用户在客户平台的唯一ID
                  (data) => {
                    // is_added == false 弹出
                    this.is_added = data.data.is_added
                    if (data.data.is_added == false) {
                      this.codeVisible = true
                    }

                    if (this.is_added == true) {
                      if (this.applyParams.type == 'course') {
                        this.$bus.emit('applyCourse', { isFillForm: '1', surveyForm: this.surveyForm })
                      } else {
                        this.$bus.emit('apply', { isFillForm: '1', surveyForm: this.surveyForm })
                      }

                      this.$refs.applyFormRef.resetFields()
                      this.applyVisible = false
                      window.location.reload()
                    }
                  }
                )
              }
            }
          )
        }
      } catch (errorInfo) {
        // console.log('Failed:', errorInfo.outOfDate)
      }
    },
    handleCancel() {
      this.$refs.applyFormRef.resetFields()
    },
    codeModalCancel() {
      this.$refs.applyFormRef.resetFields()
      this.applyVisible = false
      window.location.reload()
    },
  },
}
</script>

<style lang="less" scoped>
.applyDialog {
  h3 {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
    margin-bottom: 24px;
  }

  p.tips {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;

    i {
      color: #ff4d4f;
    }
  }

  .ant-btn-link {
    padding: 0;
  }

  .agreeBox {
    text-align: center;
  }

  .applySubmit {
    display: block;
    margin: 0 auto;
  }
}

.codeBg {
  position: relative;
  width: 430px;
  height: 560px;
  background: url('@/assets/images/popBG.png') no-repeat;
  background-size: 100%;
  margin: 0 auto;
}

.server_qrcode {
  width: 268px;
  height: 268px;
  position: absolute;
  top: 211px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
